"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const types_1 = require("./types");
class ExtraBoldStyle {
    constructor() {
        this.name = types_1.FontStyleName.EXTRABOLD;
        this.style = graphql_schema_types_1.FontStyle.Normal;
        this.weight = 800;
    }
}
exports.default = ExtraBoldStyle;
//# sourceMappingURL=ExtraBoldStyle.js.map